import React from 'react';

import { updateTaskOnServerAction } from 'actions/task';
import { CheckRadio } from 'screens/home/tasksList/styles';

import { UncheckedCircle } from 'constants/icons';

import { toggleCompletion } from 'services/helpers/task';

export default function MarkComplete({ taskId, taskKey, dispatch, isComplete, ...props }) {
  function onChange(e) {
    e.stopPropagation();
    dispatch(updateTaskOnServerAction({ id: taskId, key: taskKey, action: toggleCompletion }));
  }
  return (
    <CheckRadio
      onClick={onChange}
      disableRipple
      checked={isComplete}
      checkedIcon={<UncheckedCircle size="tiny" color="green" />}
      icon={<UncheckedCircle size="tiny" color="textSecondary" />}
      {...props}
    />
  );
}
